import React, { useEffect, useState } from 'react';
import { apiDelete, apiGet, apiPut } from '../../../API/Api_Url';
import { X, MapPin, Calendar, DollarSign, FileCheck, DeleteIcon } from 'lucide-react';
import { FaCheckCircle, FaEdit, FaEye } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import FreelancerPaymentModeModal from '../../Modal/FreelancerPaymentModeModal';
import DeleteMilestoneModal from '../../Modal/DeleteMilestoneModal';
import JobCompleteModal from '../../Modal/JobCompleteModal';

function UserAllFreelancerInConstructionJobPost({ RequirementState, setRequirementState }) {
    const navigate = useNavigate();
    const [FreelancerJobPost, setFreelancerJobPost] = useState([]);
    const [isUploading, setIsUploading] = useState(false);

    const GetUserAllFreelancerInConstructionJobPost = async () => {
        try {
            setIsUploading(true);
            const response = await apiGet('api/user/UserGetAllFreelancerInConstructionJobPost');
            setFreelancerJobPost(response.data);
            setIsUploading(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsUploading(false);
        }
    };

    useEffect(() => {
        GetUserAllFreelancerInConstructionJobPost();
    }, []);

    const getStatusColor = (status) => {
        switch (status) {
            case 'Pending':
                return 'bg-yellow-100 text-yellow-800 border-yellow-200';
            case 'Approved':
            case 'Accepted':
                return 'bg-green-100 text-green-800 border-green-200';
            case 'Rejected':
                return 'bg-red-100 text-red-800 border-red-200';
            default:
                return 'bg-gray-100 text-gray-800 border-gray-200';
        }
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    const [PaymentModeModal, setPaymentModeModal] = useState(false);
    const [SelectedRequirement, setSelectedRequirement] = useState(null);

    const OpenPaymentModel = (data) => {
        setPaymentModeModal(true)
        setSelectedRequirement(data)
    }
    const ClosePaymentModel = () => {
        setPaymentModeModal(false)
        setSelectedRequirement(null)
    }

    const [DeleteMilestone, setDeleteMilestone] = useState(false);
    const [reqId, setreqId] = useState(null);
    const [milestoneid, setmilestoneid] = useState(null);

    const OpenDeleteMilestone = (requirementId, milestoneId) => {
        setreqId(requirementId)
        setmilestoneid(milestoneId)
        setDeleteMilestone(true)
    }
    const CloseDeleteMilestone = () => {
        setreqId(null)
        setmilestoneid(null)
        setDeleteMilestone(false)
    }

    const handleDeleteMilestone = async () => {
        try {
            const response = await apiDelete(
                `api/user/UserDeleteMilestone/${reqId}/${milestoneid}`
            );
            toast.success(response?.message || "Milestone deleted successfully");
            CloseDeleteMilestone()
            GetUserAllFreelancerInConstructionJobPost();
        } catch (error) {
            console.error("Error deleting milestone:", error);
            toast.error("Failed to delete milestone");
        }
    };


    const [Completedjob, setCompletedjob] = useState(false);


    const OpenCompletedjobModel = (requirementId) => {
        setreqId(requirementId)
        setCompletedjob(true)
    }
    const CloseCompletedjob = () => {
        setreqId(null)
        setCompletedjob(false)
    }


    const handleUserCompleteJobPost = async () => {
        try {
            const response = await apiPut(
                `api/user/UserCompleteJobPost/${reqId}`
            );
            toast.success(response?.message || "Job Complete And Moved to completed Section ");
            setCompletedjob()
            GetUserAllFreelancerInConstructionJobPost();
        } catch (error) {
            console.error("Error deleting milestone:", error);
            toast.error("Failed to delete milestone");
        }
    };



    return (
        <div className="p-6 bg-gradient-to-br from-blue-50 to-indigo-100 min-h-screen">
            <div className="max-w-7xl mx-auto">
                <div className="mb-8 flex flex-col md:flex-row md:items-center md:justify-between">
                    <div>
                        <h1 className="text-3xl font-bold text-gray-900 mb-1 md:mb-0">
                            My All Freelancer Job Posts
                        </h1>
                        <p className="text-gray-600">Manage and track your freelancer job posts</p>
                    </div>

                    <div className="mt-4 md:mt-0">
                        <select
                            value={RequirementState}
                            onChange={(e) => setRequirementState(e.target.value)}
                            className="border border-gray-300 rounded-lg px-4 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#0060B9]"
                        >
                            <option value="All">All</option>
                            <option value="pending">Pending</option>
                            <option value="Selected">Selected</option>
                            <option value="AgreementPending">Agreement Pending</option>
                            <option value="InConstruction">In Construction</option>
                            <option value="Completed">Completed</option>
                        </select>
                    </div>
                </div>
                {isUploading ? (
                    <div className="flex items-center justify-center py-20">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
                        <p className="ml-4 text-gray-600">Loading your projects...</p>
                    </div>
                ) : FreelancerJobPost?.length === 0 ? (
                    <div className="text-center py-20">
                        <p className="text-xl text-gray-500">No Freelancer Job Posts found.</p>
                        <p className="text-gray-400 mt-2">Create your first job post to get started.</p>
                    </div>
                ) : (
                    <div className="grid gap-6 grid-cols-1">
                        {FreelancerJobPost?.map((req) => (
                            <div key={req?._id} className="bg-white rounded-2xl shadow-lg p-6 space-y-4">
                                <div className="flex justify-between items-start">
                                    <h3 className="text-xl font-bold text-gray-900">{req?.Title}</h3>
                                    <span
                                        className={`px-3 py-1 text-xs font-semibold rounded-full border ${getStatusColor(
                                            req?.Status
                                        )}`}
                                    >
                                        {req?.Status}
                                    </span>
                                </div>
                                <p className="text-gray-700">{req?.Description}</p>
                                {req?.Skillsrequire?.length > 0 && (
                                    <p className="text-sm text-gray-600">
                                        <span className="font-medium">Skills Required:</span>{" "}
                                        {req?.Skillsrequire.join(", ")}
                                    </p>
                                )}
                                <div className="grid grid-cols-2 gap-4 text-sm">
                                    <div className="flex items-center text-gray-700">
                                        <DollarSign className="h-4 w-4 mr-2 text-purple-500" />
                                        <p>
                                            <span className="font-medium">Budget:</span> ₹{req?.Budget}
                                        </p>
                                    </div>
                                    <div className="flex items-center text-gray-700">
                                        <Calendar className="h-4 w-4 mr-2 text-orange-500" />
                                        <p>
                                            <span className="font-medium">Timeline:</span>{" "}
                                            {formatDate(req?.timeline?.startDate)} -{" "}
                                            {formatDate(req?.timeline?.endDate)}
                                        </p>
                                    </div>
                                </div>

                                {req?.location && (
                                    <div className="flex items-start text-gray-600">
                                        <MapPin className="h-4 w-4 mr-2 mt-0.5 text-blue-500" />
                                        <p className="text-sm">
                                            {req?.location?.Address}, {req?.location?.City},{" "}
                                            {req?.location?.State}
                                        </p>
                                    </div>
                                )}
                                {req?.SelectedFreelanceEngineer && (
                                    <div className="bg-blue-50 p-4 rounded-lg border text-sm text-gray-700">
                                        <h4 className="font-semibold mb-2">Selected Freelance Engineer</h4>
                                        <p>Bid ID: {req?.SelectedFreelanceEngineer?.SelectedBid}</p>
                                        <p>Engineer ID: {req?.SelectedFreelanceEngineer?.FreelanceEngineer}</p>
                                        <p>Price: ₹{req?.SelectedFreelanceEngineer?.Price}</p>
                                    </div>
                                )}

                                {req?.PaymentFlow && (
                                    <div className="bg-green-50 p-4 rounded-lg border text-sm text-gray-700">
                                        <h4 className="font-semibold mb-2">Payment Flow</h4>
                                        <p><span className="font-medium">Mode:</span> {req?.PaymentFlow?.Mode}</p>
                                        {req?.PaymentFlow?.Mode === "Milestone" && (
                                            <div className="mt-3 space-y-2">
                                                <h5 className="font-medium">Milestones:</h5>
                                                {req?.PaymentFlow?.Milestones?.map((m) => (
                                                    <div
                                                        key={m?._id}
                                                        className="border rounded-lg p-3 bg-white shadow-sm relative">
                                                        <div className="flex justify-between items-start">
                                                            <div>
                                                                <p className="font-medium">{m?.Title}</p>
                                                                <p className="text-sm text-gray-600">{m?.Description}</p>
                                                                <p>Amount: ₹{m?.Amount}</p>
                                                                <p>Status: {m?.Status}</p>
                                                                <p>Due: {formatDate(m?.DueDate)}</p>
                                                            </div>
                                                            <button
                                                                onClick={() => OpenDeleteMilestone(req?._id, m?._id)}
                                                                className="text-red-500 hover:text-red-700 text-sm ml-4"
                                                            >
                                                                <DeleteIcon />
                                                            </button>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}

                                    </div>
                                )}
                                {req?.WorkTracker?.length > 0 && (
                                    <div className="bg-gray-50 p-4 rounded-xl border mb-4">
                                        <h4 className="font-semibold text-gray-800 mb-2">Work Tracker</h4>
                                        {req?.WorkTracker.map((tracker) => (
                                            <div key={tracker?._id} className="mb-3 p-2 border rounded-md bg-white">
                                                <p className="text-sm font-medium mb-1">Title: {tracker?.Title}</p>
                                                <p className="text-sm text-gray-700 mb-1">Description: {tracker?.Description}</p>
                                                <p className="text-sm text-gray-700 mb-1">Date: {tracker?.Date}</p>
                                                <p className="text-sm text-gray-700 mb-1">
                                                    Status:{" "}
                                                    <span
                                                        className={`px-2 py-0.5 rounded-md text-xs font-medium ${tracker?.Status === "Pending"
                                                            ? "bg-yellow-100 text-yellow-700"
                                                            : "bg-green-100 text-green-700"
                                                            }`}
                                                    >
                                                        {tracker?.Status}
                                                    </span>
                                                </p>
                                                {tracker?.Media?.FileUrl && (
                                                    <a
                                                        href={tracker?.Media?.FileUrl}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="inline-block mt-2 px-3 py-1 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 transition"
                                                    >
                                                        {tracker?.Media?.FileType === "image" ? "View Image" : "View Video"}
                                                    </a>
                                                )}
                                            </div>
                                        ))}

                                    </div>
                                )}

                                <div className="flex justify-between items-center text-sm text-gray-500 pt-2">
                                    <span className="flex items-center">
                                        <Calendar className="h-4 w-4 mr-1" />
                                        Created: {formatDate(req?.createdAt)}
                                    </span>

                                    <div className="flex gap-2">
                                        <button
                                            onClick={() => OpenPaymentModel(req)}
                                            className="flex items-center gap-1 px-3 py-1 text-sm bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
                                        >
                                            <FaEdit className="h-4 w-4" />
                                            Add Payment Transaction
                                        </button>
                                        <button
                                            onClick={() => OpenCompletedjobModel(req?._id)}
                                            className="flex items-center gap-1 px-3 py-1 text-sm bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
                                        >
                                            <FaEdit className="h-4 w-4" />
                                            Make Job Status Completed.
                                        </button>
                                        <button
                                            // onClick={() => navigate(`/FreelancerJobPostDetail/${req?._id}`)}
                                            className="flex items-center gap-1 px-3 py-1 text-sm bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition"
                                        >
                                            <FaEye className="h-4 w-4" /> View Details
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

            </div>
            <FreelancerPaymentModeModal
                isOpen={PaymentModeModal}
                onClose={ClosePaymentModel}
                SelectedRequirement={SelectedRequirement}
                GetUserAllFreelancerInConstructionJobPost={GetUserAllFreelancerInConstructionJobPost}
                onSubmit={ClosePaymentModel}
            />
            <DeleteMilestoneModal
                isOpen={DeleteMilestone}
                onClose={CloseDeleteMilestone}
                onConfirm={handleDeleteMilestone}
            />

            <JobCompleteModal
                isOpen={Completedjob}
                onClose={CloseCompletedjob}
                onConfirm={handleUserCompleteJobPost}
            />


        </div>
    );
}

export default UserAllFreelancerInConstructionJobPost;
